import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"text-decoration-none",attrs:{"href":"/terms-of-service","target":"_blank"}},[_vm._v(" Terms of Service "),_c(VIcon,{attrs:{"color":"primary","small":""}},[_vm._v("mdi-open-in-new")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }